import { useQuery } from '@apollo/client';
import { GET_TENANTS_FOR_EMAIL } from 'graphql/auth/queries/getTenantsForEmail';
import { useAuthContext } from 'context/auth.context';

export default function useGetTenantsForCurrentUser() {
  const { user } = useAuthContext();

  const { data, error, loading } = useQuery(GET_TENANTS_FOR_EMAIL, {
    variables: { email: user?.user.email ?? '' },
    skip: !user?.user.email,
  });

  return {
    tenants: data?.getTenantsForEmail ?? [],
    loading,
    error,
  };
}
